export var ReportPackageType;
(function (ReportPackageType) {
    ReportPackageType["BK1"] = "BK1";
    ReportPackageType["BK2"] = "BK2";
    ReportPackageType["BK3"] = "BK3";
    ReportPackageType["BK_International"] = "BK_International";
    ReportPackageType["Basic"] = "Basic";
    ReportPackageType["Extended"] = "Extended";
    ReportPackageType["InDepth"] = "InDepth";
    ReportPackageType["International"] = "International";
})(ReportPackageType || (ReportPackageType = {}));
